import { addImposterToUrl } from 'Utils';
import { api } from './axios';
import { IPresTruncatedDataDTO } from './prescriptions';

const baseUrl = '/prescription/prescriptionsAndUhHandledOrders/v2';

export interface IPrescriptionsOrders {
  prescriptions: IPresTruncatedDataDTO[];
}
export const getPrescriptionsOrders = async () => {
  const prescriptionsOrders = await api.get<IPresTruncatedDataDTO[]>(
    addImposterToUrl(baseUrl, true)
  );

  if (prescriptionsOrders.data) {
    return prescriptionsOrders.data;
  }
};
